
import instance from './request.js'

// ajax请求封装
export function fetch(options) {
  return new Promise((resolve, reject) => {
    instance(options)
      .then(response => {
        // 把请求的数据发送到引用请求的地方
        resolve(response)
      })
      .catch(error => {
        reject(error)
      }

      )
  })
}
